import React from "react";
import { Flex, Icon, Heading, Box } from "@chakra-ui/react";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";

interface MobileHeaderProps {
  title: string;
}

export const MobileHeader: React.FC<MobileHeaderProps> = ({ title }) => {
  const navigate = useNavigate();

  return (
    <Flex
      justify={"space-between"}
      align={"center"}
      bg={"linear-gradient(to bottom right, #FFF7F3, #D8F1F2)"}
      borderBottomLeftRadius={24}
      borderBottomRightRadius={24}
      px={"20px"}
      pb={"20px"}
      pt={"54px"}
      display={{ base: "flex", md: "none" }}
    >
      <Icon fontSize={24} color={"#19202D"} onClick={() => navigate(-1)}>
        <IoIosArrowBack />
      </Icon>

      <Heading fontSize={"20px"} textAlign={"center"} color={"#19202D"}>
        {title}
      </Heading>

      <Box w={"24px"} />
    </Flex>
  );
};
